import { useEffect, useState } from 'react'
import { InputGroup, Input, InputRightElement, Button, Text } from '@chakra-ui/react'
import { EventKey } from 'configs/constants/enums/event'
import { useStores } from 'hooks/useStores'
import qs from 'qs'
import { useNavigate, useLocation } from 'react-router-dom'
import { Dropdown, DropdownMenu, DropdownToggle } from 'reactstrap'
import { ISearchPageQuery } from 'components/Pages/SearchPage'
import SvgIcon from 'components/SvgIcon'
import { EEsGlobalSearchCollection } from 'constants/elasticSearch'
import routes from 'routes'

const SearchDropdown = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const { searchStore } = useStores()
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)
  const [keyword, setKeyword] = useState<string>('')
  const query: ISearchPageQuery = qs.parse(location.search, { ignoreQueryPrefix: true })

  function toggleDropdown(): void {
    setIsDropdownOpen(!isDropdownOpen)
  }

  function gotoSearchPage(searchText: string): void {
    searchStore.clearSearchResults()
    searchStore.setManageMode(false)
    searchStore.clearSearchFilter()
    searchStore.setDisplayTypes([EEsGlobalSearchCollection.PROCESS])
    searchStore.setSearchText(searchText)
    searchStore.changeSearchFilter({
      collections: [],
      documentTypes: [],
      groups: [],
      sort: ''
    })
    searchStore.search()
    const searchResultRoute = `${routes.search.value}?searchText=${searchText}&page=1`
    navigate(searchResultRoute)
  }

  function handleSearch(event: { key: string }): void {
    if (event?.key === EventKey.ENTER) {
      gotoSearchPage(keyword)
    }
  }

  useEffect(() => {
    setKeyword(query?.searchText ?? '')
  }, [location])

  return (
    <Dropdown isOpen={isDropdownOpen} toggle={toggleDropdown}>
      <DropdownToggle
        data-toggle="dropdown"
        tag="a"
        className="nav-link dropdown-toggle arrow-none mr-0 no-caret"
        onClick={toggleDropdown}
        aria-expanded={isDropdownOpen}
      >
        <SvgIcon iconName="search" size={24} color="gray.700" />
      </DropdownToggle>
      <DropdownMenu right className="dropdown-menu-animated topbar-dropdown-menu dropdown-lg">
        <div>
          <InputGroup borderRadius="6px" background="white">
            <Input
              paddingRight={104}
              autoFocus
              type="search"
              placeholder="Enter keywords..."
              value={keyword}
              onChange={event => setKeyword(event.target.value)}
              onKeyDown={handleSearch}
            />
            <InputRightElement width="100px" paddingRight={1}>
              <Button
                height={8}
                border={0}
                background="gray.100"
                gap={2}
                padding="10px 12px"
                onClick={() => gotoSearchPage(keyword)}
              >
                <Text color="gray.700" fontFamily="Inter" fontSize="14px" fontWeight={500} lineHeight="20px">
                  Search
                </Text>
                <SvgIcon iconName="search" size={14} color="gray.700" />
              </Button>
            </InputRightElement>
          </InputGroup>
        </div>
      </DropdownMenu>
    </Dropdown>
  )
}

export default SearchDropdown
